import { all, call, getContext, put, takeEvery } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import { normalizePostArray } from "@helpers/posts";
import { setAuthors } from "../authors/actions";
import { setPosts } from "../posts/actions";
import {
  attachPostsActionTypes,
  getCreateSubscriptionPostsActionTypes,
  getMoreCreateSubscriptionPostsActionTypes,
} from "./actionTypes";
import {
  attachPostsToSubscriptionFailure,
  attachPostsToSubscriptionSuccess,
  getCreateSubscriptionPostsFailure,
  getCreateSubscriptionPostsSuccess,
  getMoreCreateSubscriptionPostsFailure,
  getMoreCreateSubscriptionPostsSuccess,
} from "./actions";
import { updateSubscriptions } from "../subscriptions/actions";
import ToastService from "../../services/ToastService";

const getCreateSubscriptionPostsAsync = ({
  PostsService,
  username,
  params,
}) => {
  if (!PostsService) {
    return;
  }

  return PostsService.getPostsByUsername(username, params);
};

function* getCreateSubscriptionPosts({ payload }) {
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);
    const { username, ...params } = payload;

    const { data, pagination } = yield call(getCreateSubscriptionPostsAsync, {
      PostsService,
      params,
      username,
    });

    const { entities, result: allPosts } = normalizePostArray(data);
    const { authors, subscriptions, posts: postById } = entities;
    const { totalCount } = pagination;

    yield all([
      put(setAuthors(authors)),
      put(updateSubscriptions({ subscriptions })),
      put(setPosts({ postById })),
      put(getCreateSubscriptionPostsSuccess({ allPosts, totalCount })),
    ]);
  } catch ({ error }) {
    ToastService.error(error?.message);
    yield put(getCreateSubscriptionPostsFailure(error));
  }
}

function* getCreateSubscriptionPostsPortion({ payload }) {
  try {
    const { PostsService } = yield getContext(CONTEXT.SERVICES);
    const { username, ...params } = payload;

    const { data, pagination } = yield call(getCreateSubscriptionPostsAsync, {
      PostsService,
      params,
      username,
    });

    const { entities, result: allPosts } = normalizePostArray(data);
    const { authors, subscriptions, posts: postById } = entities;
    const { totalCount } = pagination;

    yield all([
      put(setAuthors(authors)),
      put(updateSubscriptions({ subscriptions })),
      put(setPosts({ postById })),
      put(
        getMoreCreateSubscriptionPostsSuccess({
          allPosts,
          totalCount,
        }),
      ),
    ]);
  } catch ({ error }) {
    yield put(getMoreCreateSubscriptionPostsFailure(error));
  }
}

const attachPostAsync = ({ SubscriptionsService, id, model }) => {
  if (!SubscriptionsService) {
    console.log("Required services does not exist");
    return;
  }

  return SubscriptionsService.attachPost(id, model);
};

function* attachPost({ payload }) {
  try {
    const { id, model } = payload;
    const { SubscriptionsService } = yield getContext(CONTEXT.SERVICES);

    yield call(attachPostAsync, { SubscriptionsService, id, model });

    yield put(attachPostsToSubscriptionSuccess());
  } catch ({ error }) {
    yield put(attachPostsToSubscriptionFailure(error));
  }
}

export function* watchGetCreateSubscriptionPosts() {
  yield takeEvery(
    getCreateSubscriptionPostsActionTypes.request,
    getCreateSubscriptionPosts,
  );
}

export function* watchGetMoreCreateSubscriptionPosts() {
  yield takeEvery(
    getMoreCreateSubscriptionPostsActionTypes.request,
    getCreateSubscriptionPostsPortion,
  );
}

export function* watchAttachPosts() {
  yield takeEvery(attachPostsActionTypes.request, attachPost);
}
